import { createClient } from "@supabase/supabase-js";

// Supabase connection — values come from .env (REACT_APP_ prefix is required by CRA).
// The anon key is public and safe in the browser; access is gated by Row Level Security.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// `isSupabaseConfigured` lets the app degrade gracefully (fall back to localStorage)
// when env vars are missing, instead of crashing at import time.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY. " +
      "Running without a backend — data will not sync."
  );
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export default supabase;
